import { Alert, IconButton } from '@components'
import type { Notification } from '@here/api'
import { A } from '@solidjs/router'
import { useNotifications } from '@state'
import {
	ArrowRight,
	AtSign,
	CalendarFold,
	MessageSquare,
	MessagesSquare,
	X,
} from 'lucide-solid'
import { Show } from 'solid-js'
import { useService } from 'solid-services'
import { Flex, Grid } from 'styled-system/jsx'

export default function (props: {
	notification?: Notification
	onAction?: () => void
}) {
	const { setDeleteNotification } = useService(useNotifications)()

	const title = () => {
		switch (props.notification?.notification_type) {
			case 'calendar-event':
				return {
					title: 'Event',
					icon: <CalendarFold />,
				}

			case 'unread-mention':
				return {
					title: 'Unread Mention',
					icon: <AtSign />,
				}

			case 'unread-messages':
				return {
					title: 'Unread Messages',
					icon: <MessageSquare />,
				}
		}
	}

	const deleteNotification = () => {
		setDeleteNotification(props.notification!.id)
		props.onAction?.()
	}

	return (
		<Show when={props?.notification}>
			<Alert.Root
				border="none"
				p={4}
			>
				<Alert.Icon asChild={() => title()?.icon} />
				<Alert.Content width="100%">
					<Grid gridTemplateColumns="1fr auto">
						<Grid>
							<Alert.Title>{title()?.title}</Alert.Title>
							<Alert.Description>{props.notification!.message}</Alert.Description>
						</Grid>
						<Flex
							flexDirection="column"
							justifyContent="end"
						>
							<A href={props.notification!.resolve_path}>
								<IconButton
									onClick={deleteNotification}
									height="6"
									width="6"
									colorPalette="tscGreen"
									variant="ghost"
								>
									<ArrowRight />
								</IconButton>
							</A>
							<IconButton
								onClick={deleteNotification}
								height="6"
								width="6"
								colorPalette="tscGreen"
								variant="ghost"
							>
								<X />
							</IconButton>
						</Flex>
					</Grid>
				</Alert.Content>
			</Alert.Root>
		</Show>
	)
}
